export default __webpack_public_path__ + "static/media/benefits-bg-02.93337739.png";